import { ReactElement } from 'react';
import { WithCount } from '@client/catalog/components/WithCount';
import { getFacetFilterKey } from '@client/catalog/utils/facets';
import { translateFilterOption } from '@client/catalog/utils/filters';
import { useTranslate } from '@client/i18n/hooks';
import { getComponentDataAttributes } from '@lib/utils/getComponentDataAttributes';
import { Checkbox } from 'b2b-components/theme/components/Form/Checkbox/Checkbox';
import { Props } from './Section.types';

export const Section = ({
  filterGroup,
  onOptionChange,
  dataAttributes,
}: Props): ReactElement => {
  const t = useTranslate();

  return (
    <div
      {...getComponentDataAttributes(dataAttributes)}
      className='cds-Form-Selectable'
    >
      {filterGroup.elements.map(({
        value,
        count,
        checked,
      }) => {
        const filterKey = getFacetFilterKey(value, !!checked);
        return (
          <WithCount count={count} key={filterKey}>
            <Checkbox
              isDefaultChecked={checked}
              label={translateFilterOption(t, filterGroup.field, value)}
              onChange={() => onOptionChange(value)}
            />
          </WithCount>
        );
      })}
    </div>
  );
};
